import { FC, Fragment, useReducer } from 'react';

import { Plus } from 'lucide-react';
import { toast } from 'sonner';
import useSWRMutation from 'swr/mutation';

import Button from '@mui/material/Button';

import { initialValues } from '../form';
import { VideoFormDialog } from '../videoFormDialog/VideoFormDialog';

import { videoService } from 'v2/api/videoService';
import { VideoForm } from 'v2/types/VideoModel';
import { handleHttpError } from 'v2/utils';

interface CreateVideoButtonProps {
  onSuccess: VoidFunction;
}

export const CreateVideoButton: FC<CreateVideoButtonProps> = ({ onSuccess }) => {
  const [isOpen, setOpen] = useReducer((state) => !state, false);

  const { trigger, isMutating } = useSWRMutation('createVideo', videoService.createVideo, {
    onSuccess: () => {
      onSuccess();
      toast.success('The video has been successfully created');
      setOpen();
    },
    onError: handleHttpError,
  });

  const handleSubmit = (values: VideoForm, resetForm: VoidFunction) => {
    trigger(values).then(() => {
      resetForm();
    });
  };

  return (
    <Fragment>
      <Button onClick={setOpen} startIcon={<Plus />} variant="contained" size="large">
        Add Video
      </Button>

      <VideoFormDialog
        title="Create Video"
        isOpen={isOpen}
        onClose={setOpen}
        initialValues={initialValues}
        isSubmitting={isMutating}
        onSubmit={handleSubmit}
      />
    </Fragment>
  );
};
